import React from 'react';
import TextInput from 'src/ui/library/TextInput';
import TextMask from './TextMask';

const normalizeInputValue = value => (value === null || value === undefined ? '' : String(value));

class PhoneInput extends React.Component {
  state = {
    value: normalizeInputValue(this.props.value),
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: normalizeInputValue(this.props.value) });
    }
  }

  handleChange = event => {
    if (this.props.onChange) {
      this.props.onChange(event);
    }

    this.setState({
      value: event.target.value,
    });
  };

  render() {
    const { onChange, value, ...otherProps } = this.props;

    return (
      <TextInput
        onChange={this.handleChange}
        InputProps={{
          inputComponent: TextMask,
          value: this.state.value,
        }}
        {...otherProps}
      />
    );
  }
}

export default PhoneInput;
